/**
 * LiveKit SDK Initialization
 * 
 * This file initializes the LiveKit SDK with app-specific configuration.
 * Import and call this once in your app's entry point (e.g., App.tsx or index.tsx).
 */

import { initializeLiveKitSDK } from '@hosaksham/livekit-meeting-sdk';
import { db, SECRETS_ENV } from '../Config/firebase';
import ChequeredChess from '../app/Subscriptions/Pages/SubscriptionDetails/Components/ChequeredChess';
import PollsQuizzes from '../app/Subscriptions/Pages/SubscriptionDetails/Components/PollsQuizzes';

// High Quality Recording Feature Flag
// Set to true to enable premium high-quality recording (720p, higher bitrates)
// Default: false (480p, optimized for 150-200 MB/hour file size)
const HQ_Enabled = false;

/**
 * Initialize the LiveKit SDK with our app's configuration
 * Call this once when the app starts
 */
export const initLiveKitSDK = () => {
    initializeLiveKitSDK({
        firebaseDb: db,
        apiEndpoint: SECRETS_ENV.API_END_POINT,
        ChessComponent: ChequeredChess,
        PollsComponent: PollsQuizzes,
        hqEnabled: HQ_Enabled
    });
    
    console.log('✅ LiveKit SDK initialized for SMP-Subscriptions-Web');
};

